import { version } from '../../package.json';

export const APP_BUILD_VERSION: string = version;
